@for (column of columns; track trackByIndex($index, column)) {
  <div [class]="'lm-undistributed-column'">
    @if (column) {
      <lm-element
        [layoutObject]="column"
        [layoutInfo]="layoutInfo"
        [lmColumnLayoutInfo]="lmColumnLayoutInfo"
        [specFields]="specFields"
        [placeHolder]="placeHolder"
        [model]="model"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-element>
    }
  </div>
}
